export default __webpack_public_path__ + "static/media/ProfilePhoto.511f6151.jpg";